import styled from 'styled-components';

export const VersionModalContent = styled.div`
  max-height: 500px;
  overflow-y: auto;
  padding: 0 8px;
`;

export const VersionHeader = styled.div`
  margin-bottom: 1rem;

  p {
    margin: 0.5rem 0 0 0;
    color: #666;
    font-size: 0.9rem;
  }
`;

export const VersionSection = styled.div`
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`;

export const ChangeList = styled.ul`
  margin: 0.5rem 0 0 1rem;
  padding: 0;
  list-style: none;
`;

export const ChangeItem = styled.li`
  margin-bottom: 0.25rem;
  padding-left: 0.5rem;
  position: relative;

  &::before {
    content: '•';
    color: #007bff;
    font-weight: bold;
    position: absolute;
    left: 0;
  }
`;

export const ChangeCategory = styled.div`
  margin-bottom: 0.75rem;

  strong {
    color: #333;
    font-size: 0.9rem;
    display: block;
    margin-bottom: 0.25rem;
  }
`;
